import React, { useState } from "react";
import styled, { css } from "styled-components";
import { useNavigate } from "react-router";

import { MainLayout } from "layouts";
import Text from "components/ui/Text";
import Button from "components/entrance/Button";
import TermsCheckOn from "assets/icons/terms_check_on.svg";
import TermsCheckOff from "assets/icons/terms_check_off.svg";
import { removeAccount } from "api/signin";

const RemoveAccount = () => {
  const navigate = useNavigate();
  const [isChecked, setIsChecked] = useState(false);

  const handleClickRemoval = async () => {
    try {
      const res = await removeAccount();
      if (res) {
        navigate("/entrance");
      }
    } catch (error) {}
  };

  return (
    <MainLayout
      withBottomTab={false}
      withHeader={true}
      backgroundColor="white"
      headerProps={{ withBackButton: true, centerTitle: "계정 탈퇴" }}
    >
      <Wrapper>
        <TopBox>
          <Text
            color="gray100"
            fontSize="22px"
            fontWeight="600"
            lineHeight="32px"
            css={css`
              margin-bottom: 8px;
            `}
          >
            계정 탈퇴 전 꼭 확인해주세요!
          </Text>
          <Text
            color="gray80"
            fontSize="16px"
            fontWeight="400"
            lineHeight="24px"
            css={css`
              margin-bottom: 24px;
            `}
          >
            관리자 앱 탈퇴 전 아래의 사항을 확인해주세요.
          </Text>
          <Text
            color="gray40"
            fontSize="16px"
            fontWeight="400"
            lineHeight="24px"
          >
            관리자 앱을 탈퇴하면, <br />
            ・ 탈퇴 시 즉시 연동되었던 모든 관리센터의 연동이 해제됩니다.
            <br />
            ・ 바디코디 관리자앱은 바디코디 회원관리 프로그램에 관리자앱
            사용자로 등록된 분만 이용하실 수 있습니다.
            <br />
            ・ 탈퇴 후 재가입 시 관리자앱 사용자 재등록이 필요합니다.
            <br />
            ・ 회원탈퇴 후 탈퇴일에는 재가입이 불가능합니다.
            <br />
            ・ 탈퇴 후 다음날 12시부터 재가입할 수 있습니다.
            <br />・ 관리자앱을 탈퇴하더라도 앱에 저장된 개인정보는 즉시
            삭제되지만, 바디코디 회원관리 프로그램에 등록된 관리자 정보는
            삭제되지 않습니다.
          </Text>
        </TopBox>
        <BottomBox>
          <WrapperText
            onClick={() => setIsChecked((previousValue) => !previousValue)}
          >
            <Img
              src={isChecked ? TermsCheckOn : TermsCheckOff}
              alt="checked"
              width="20px"
              height="20px"
            />
            <Text color="gray80" fontWeight="400" lineHeight="24px">
              위 내용을 모두 이해하였으며 동의합니다.
            </Text>
          </WrapperText>
          <Button
            color={isChecked ? "white" : "disable"}
            background={isChecked ? "danger" : "gray5"}
            onClick={isChecked ? handleClickRemoval : () => {}}
          >
            관리자 앱 계정 탈퇴
          </Button>
        </BottomBox>
      </Wrapper>
    </MainLayout>
  );
};

const Wrapper = styled.div`
  width: 100%;
  height: calc(100% - 52px);
  padding: 16px 20px 0px 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const TopBox = styled.div`
  overflow-y: scroll;
`;

const BottomBox = styled.div`
  margin: 24px 0 42px;
`;
const WrapperText = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-bottom: 32px;
`;
const Img = styled.img`
  display: inline-block;
  margin-right: 10px;
`;

export default RemoveAccount;
